import { AnimatePresence, motion } from "framer-motion";
import { InfoGradient } from "components/icons/InfoGradient";
import { ReactNode, useEffect, useRef } from "react";

type SnackbarType = "info";

const snackbarIcon: Record<SnackbarType, ReactNode> = {
  info: <InfoGradient />,
};

type SnackbarProps = {
  isOpen: boolean;
  onClose: () => void;
  children?: ReactNode;
  duration?: number;
  type?: SnackbarType;
};

export const Snackbar = ({
  isOpen,
  onClose,
  children,
  duration = 8000,
  type = "info",
}: SnackbarProps) => {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (!isOpen) return;

    timerRef.current = setTimeout(() => {
      onClose();
    }, duration);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [isOpen, duration, onClose]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
          className="t-fixed t-bottom-0 t-flex t-items-center t-justify-center t-py-10 t-px-10  t-z-popover t-inset-x-0"
        >
          <div className="moving_border_snackbar t-shadow-light-60 t-rounded-lg t-flex t-justify-center t-items-center t-gap-4 t-p-4 t-bg-white">
            {snackbarIcon[type]}
            {children}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
